export default () => ({
  trigger: {
    name: 'chatbot.start_live_chat',
    params: {},
  },
  config: {
    event: {
      name: 'start_feature',
      params: {
        sub_feature: 'live_chat',
        item_ids: null,
      },
    },
  },
});
